import type { SiteDashboardApiResponse } from '@/types/site';
import { XHRAuthorizedClient } from '../client';
import { ENDPOINTS } from '../endpoints';

export const fetchSiteDashboard = async (siteId: string) => {
  const response = await XHRAuthorizedClient.get<SiteDashboardApiResponse>(
    ENDPOINTS.dashboard.siteDashboard(siteId)
  );

  return response.data.data;
};
